import React from "react";
import Buttons from "../Buttons/Buttons";
import Radio from "@material-ui/core/Radio";
import Slide from "@material-ui/core/Slide";
import { Styles } from "../../../styles/TextRadio";
import checkedImage from "../../../images/checked.svg";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const alphabetOptions = [
	require("../../../images/a.png").default,
	require("../../../images/b.png").default,
	require("../../../images/c.png").default,
	require("../../../images/d.png").default,
	require("../../../images/e.png").default,
];

function TextRadioButton(props) {
	const style = Styles();
	const { radioData, onRadioBtnChange, index, questionData } = props;

	return (
		<>
			<Slide
				in={true}
				mountOnEnter
				direction="up"
				unmountOnExit
				{...(true ? { timeout: 500 } : {})}
				style={{ transformOrigin: "0 0 0" }}
			>
				<div className="col-sm-4">
					<span className={style.span}>
						Question
						<span className={style.questionCount}>
							{index + 1} / {questionData.length}
						</span>
					</span>
					<h1
						className={style.h1}
						dangerouslySetInnerHTML={{ __html: radioData.question }}
					></h1>
					<p
						className={style.p}
						dangerouslySetInnerHTML={{ __html: radioData.subhead }}
					></p>
					<div>
						<Buttons
							{...props}
							style={style}
							btnData={radioData}
							className={style.desktop}
						/>
					</div>
				</div>
			</Slide>
			<Slide
				in={true}
				mountOnEnter
				direction="up"
				unmountOnExit
				style={{ transformOrigin: "0 0 0" }}
				{...(true ? { timeout: 1000 } : {})}
			>
				<div className="col-sm-8">
					<div className="row" style={{ justifyContent: "center" }}>
						{radioData.options.map((elem, i) => (
							<FormControlLabel
								key={elem.id}
								className={style.radioTextLabel}
								control={
									<Radio
										value={elem.id}
										checked={elem.checked}
										className={style.root}
										onChange={onRadioBtnChange}
									/>
								}
								label={
									<div
										className={
											elem.checked
												? style.textButtonAfterSelect
												: style.textButton
										}
									>
										{elem.checked ? (
											<img
												src={checkedImage}
												alt="Checked Option"
												className={style.imageSelected}
											/>
										) : (
											""
										)}
										<img src={alphabetOptions[i]} alt="Radio Text" />
										<h4 className={style.h4}>{elem.option}</h4>
									</div>
								}
							/>
						))}
					</div>
					<div>
						<Buttons
							{...props}
							style={style}
							btnData={radioData}
							className={style.mobile}
						/>
					</div>
				</div>
			</Slide>
		</>
	);
}

export default TextRadioButton;
